import { render, staticRenderFns } from "./FirebaseSettings.vue?vue&type=template&id=4471bbc3&"
import script from "./FirebaseSettings.vue?vue&type=script&lang=js&"
export * from "./FirebaseSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports